export default "__VITE_ASSET__BArz1q1X__"